import { jsx as _jsx } from "react/jsx-runtime";
import { UXPContext } from '@core/context/Context';
import classNames from 'classnames';
import { forwardRef, useContext, useImperativeHandle, useRef } from 'react';
import ReactQRCode from 'react-qr-code';
/**
 * @export
 * A reusable QR code component with optional print support and UXP theming.
 * Wraps `react-qr-code` and supports context-based styling.
 *
 */
export const QRCodeComponent = forwardRef((props, ref) => {
    var _a, _b;
    const context = useContext(UXPContext);
    const { value, size = 128, bgColor = ((_a = context === null || context === void 0 ? void 0 : context.theme) === null || _a === void 0 ? void 0 : _a.primaryBGColor) || '#FFF', fgColor = ((_b = context === null || context === void 0 ? void 0 : context.theme) === null || _b === void 0 ? void 0 : _b.primaryTextColor) || '#000', className, style, printStyles, shadow = true, printOnClick = true } = props;
    const printRef = useRef(null);
    const printQRCode = () => {
        const win = window.open('', '_blank', 'width=800,height=400');
        if (win && printRef.current) {
            const doc = win.document;
            const html = document.createElement('html');
            const head = document.createElement('head');
            const title = document.createElement('title');
            title.textContent = 'Print QR Code';
            const styleEl = document.createElement('style');
            styleEl.textContent = `
                    body {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                        height: 100vh;
                        margin: 0;
                    }
                    svg {
                        width: 400px !important;
                        height: 400px !important;
                        ${printStyles || {}}
                    }
                `;
            head.appendChild(title);
            head.appendChild(styleEl);
            const body = document.createElement('body');
            body.innerHTML = printRef.current.innerHTML;
            html.appendChild(head);
            html.appendChild(body);
            doc.documentElement.replaceWith(html);
            doc.close();
            setTimeout(() => {
                win.focus();
                win.print();
                win.close();
            }, 100);
        }
    };
    useImperativeHandle(ref, () => ({
        print: printQRCode
    }));
    return (_jsx("div", { className: classNames('uxpcore_qrcode__container', className, {
            'uxpcore_qrcode__container--has-shadow ': shadow
        }), style: style, ref: printRef, onClick: printQRCode, children: _jsx(ReactQRCode, { value: value, bgColor: bgColor, fgColor: fgColor, size: size }) }));
});
